
export enum LegacyTicketBookingStrategy {
  Standard = 'Standard',
  CalendarBooking = 'CalendarBooking',
  TicketAsOpenAccessPass = 'TicketAsOpenAccessPass',
}
